import {
    NAVIGATION_RECEIVE,
    NAVIGATION_TOP_MENU
} from '../Actions/Navigation.action'

const defaultState = {
    contentLinks: [],
    linkToOtherSites: [],
    additionalHeaderLinks: [],
    mobileNavigation: []
}

export const navigation = (state = defaultState, action) => {
    switch (action.type) {
        case NAVIGATION_RECEIVE:
            return {
                ...state,
                ...action.payload
            }
        case NAVIGATION_TOP_MENU:
            return {
                ...state
            }
        default:
            return state
    }
}
